import React from "react";

import {useHistory} from "react-router-dom";
import {BudgetingType} from "../../../BudgetingType";

import {Tab, TabList} from "@zendeskgarden/react-tabs";

import {getAbbreviatedYear} from "../../../utils/helper-funcs";

import * as workflowCSS from "../../../styles/workflows/workflowCSS.module.scss";
import {yearTabsRow} from "../../../styles/workflows/workflowCSS.module.scss";
import {ForecastLocks, GetForecastLocksQuery} from "../../../__generated__/generated_types";

import {ReactComponent as LockIcon} from '@zendeskgarden/svg-icons/src/16/lock-locked-stroke.svg';
import LockBanner from "../../../pages/workflows/account/LockBanner";
import {TLockOverrides} from "../../../authorization/AuthorizationCheckers";
import {Property} from "../../../contexts/properties/logic";

interface IWorkflowYearTabs {
    property: Property;
    selectedTab?: string;
    rawForecastLocks?: GetForecastLocksQuery | undefined,
    forecastLocks?: ForecastLocks | undefined,
    lockOverrides?: TLockOverrides | undefined,
}

export const WORKFLOW_YEAR_TAB_REFORECAST = 'WORKFLOW_YEAR_TAB_REFORECAST';
export const WORKFLOW_YEAR_TAB_BUDGET = 'WORKFLOW_YEAR_TAB_BUDGET';
export const WORKFLOW_YEAR_TAB_COMBINED = 'WORKFLOW_YEAR_TAB_COMBINED';

function WorkflowYearTabsNormal(props: IWorkflowYearTabs): ReturnType<typeof TabList> {
    const history = useHistory();
    const year = props.property.reforecastYear;

    const performNav = (activeTab: string) => {
        history.push(activeTab);
    };

    function showLockBanner(): boolean {
        if (!props.rawForecastLocks?.forecastLocks) {
            return false;
        }

        if (props.selectedTab == WORKFLOW_YEAR_TAB_REFORECAST) {
            return props.rawForecastLocks.forecastLocks.property.reforecastLocked ?? false;
        } else if (props.selectedTab == WORKFLOW_YEAR_TAB_BUDGET) {
            return props.rawForecastLocks.forecastLocks.property.budgetLocked ?? false;
        } else {
            return false;
        }
    }

    const period = `${props.selectedTab == WORKFLOW_YEAR_TAB_REFORECAST ? year : (year + 1)} ${props.selectedTab == WORKFLOW_YEAR_TAB_REFORECAST ? "Reforecast" : "Budget"}`;
    const lockBannerText = `${period} has been finalized. No edits are permitted.`;

    return (
            <div className={yearTabsRow}>
                {showLockBanner() ?
                        <LockBanner fixed text={lockBannerText} />
                        : <></>
                }
                <TabList className={workflowCSS.accountYearTabNav}>
                    <Tab item={WORKFLOW_YEAR_TAB_REFORECAST}
                         className={workflowCSS.accountYearTab}
                         onClick={() => {
                             performNav(BudgetingType.REFORECAST);
                         }}
                    >
                        { props.forecastLocks?.reforecastLocked && !props.lockOverrides?.reforecast ?
                                <LockIcon className={workflowCSS.tabLockIcon} />
                                : <></>
                        }
                        Reforecast {getAbbreviatedYear(year)}
                    </Tab>
                    <Tab item={WORKFLOW_YEAR_TAB_BUDGET}
                         className={workflowCSS.accountYearTab}
                         onClick={() => {
                             performNav(BudgetingType.BUDGET);
                         }}
                    >
                        { props.forecastLocks?.budgetLocked && !props.lockOverrides?.budget ?
                                <LockIcon className={workflowCSS.tabLockIcon} />
                                : <></>
                        }
                        Budget {getAbbreviatedYear(year + 1)}
                    </Tab>
                </TabList>
            </div>
    );
}

function WorkflowYearTabsAcquisition(props: IWorkflowYearTabs): ReturnType<typeof TabList> {
    const history = useHistory();

    const performNav = (activeTab: string) => {
        history.push(activeTab);
    };

    function showLockBanner(): boolean {
        if (!props.rawForecastLocks?.forecastLocks) {
            return false;
        }

        if (props.selectedTab == WORKFLOW_YEAR_TAB_REFORECAST) {
            return props.rawForecastLocks.forecastLocks.property.reforecastLocked ?? false;
        } else if (props.selectedTab == WORKFLOW_YEAR_TAB_BUDGET) {
            return props.rawForecastLocks.forecastLocks.property.budgetLocked ?? false;
        } else {
            return false;
        }
    }

    const period = `${props.selectedTab == WORKFLOW_YEAR_TAB_REFORECAST ? "Year 1" : "Year 2"}`;
    const lockBannerText = `${period} has been finalized. No edits are permitted.`;

    return (
            <div className={yearTabsRow}>
                {showLockBanner() ?
                        <LockBanner fixed text={lockBannerText} />
                        : <></>
                }
                <TabList className={workflowCSS.accountYearTabNav}>
                    <Tab item={WORKFLOW_YEAR_TAB_REFORECAST}
                         className={workflowCSS.accountYearTab}
                         onClick={() => {
                             performNav(BudgetingType.REFORECAST);
                         }}
                    >
                        { props.forecastLocks?.reforecastLocked && !props.lockOverrides?.reforecast ?
                                <LockIcon className={workflowCSS.tabLockIcon} />
                                : <></>
                        }
                        Year 1
                    </Tab>
                    <Tab item={WORKFLOW_YEAR_TAB_BUDGET}
                         className={workflowCSS.accountYearTab}
                         onClick={() => {
                             performNav(BudgetingType.BUDGET);
                         }}
                    >
                        { props.forecastLocks?.budgetLocked && !props.lockOverrides?.budget ?
                                <LockIcon className={workflowCSS.tabLockIcon} />
                                : <></>
                        }
                        Year 2
                    </Tab>
                </TabList>
            </div>
    );
}

export default function WorkflowYearTabs(props: IWorkflowYearTabs): ReturnType<typeof TabList> {
    if(props.property.isAcquisitionProperty) {
        return <></>;
    }

    return <WorkflowYearTabsNormal {...props} />;
}